import { render, staticRenderFns } from "./perubahan_znt_terseleksi.vue?vue&type=template&id=5df287e4&"
import script from "./perubahan_znt_terseleksi.vue?vue&type=script&lang=js&"
export * from "./perubahan_znt_terseleksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports